import { render, staticRenderFns } from "./ContractLimitTransaction.vue?vue&type=template&id=4b173108&"
import script from "./ContractLimitTransaction.vue?vue&type=script&lang=js&"
export * from "./ContractLimitTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports